import {
  FormField,
  FormSubmitButton,
  FormWrapper,
} from "@/components/form/common";
import { Input, Textarea } from "@/components/form/fields";
import { editUserPermission } from "@/pages/admin/users/permissions/lib/actions";
import { useNavigate } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { useEffect } from "react";

export const EditUserPermissionForm = ({ userPermission }) => {
  const navigate = useNavigate();
  const {
    control,
    handleSubmit,
    setError,
    formState: { errors, isSubmitting },
    reset,
  } = useForm({
    defaultValues: {
      name: userPermission?.name,
      description: userPermission?.description,
    },
  });

  useEffect(() => {
    reset(userPermission);
  }, [userPermission, reset]);

  const onSubmit = async (data) => {
    try {
      const response = await editUserPermission(
        userPermission?.id,
        data,
        navigate,
      );

      if (response.errors) {
        Object.keys(response.errors).forEach((field) =>
          setError(field, { type: "manual", message: response.errors[field] }),
        );
      }
    } catch {
      setError("root", { type: "manual", message: "An error occurred" });
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <FormWrapper>
        <FormField name="name" label="Naam" formState={{ errors }}>
          <Controller
            name="name"
            control={control}
            rules={{ required: "Naam is required" }}
            render={({ field }) => <Input {...field} className="w-full" />}
          />
        </FormField>

        <FormField
          name="description"
          label="Omschrijving"
          formState={{ errors }}
        >
          <Controller
            name="description"
            control={control}
            rules={{ required: "Omschrijving is required" }}
            render={({ field }) => <Textarea {...field} className="w-full" />}
          />
        </FormField>

        <FormSubmitButton disabled={isSubmitting} isSubmitting={isSubmitting}>
          {isSubmitting ? "Submitting..." : "Wijzigen"}
        </FormSubmitButton>
      </FormWrapper>
    </form>
  );
};
